export default __webpack_public_path__ + "static/contact-phone-3635b704f0924abd43ea7ab63dab52ca.png";